const initialState = {
    loginStatus: {
        isLoggedIn: false,
        userId:'',
        authToken: '',
        expiresIn: 0
    },
    userData: {},
    notifyfollowModal: false
}

const reducer = (state = initialState, action) => {
    if(action.type === 'SET_LOGIN_STATUS') { 
        const newState = {
            ...state
        };
        newState.loginStatus = {
            ...newState.loginStatus,
            isLoggedIn: action.isLoggedIn,
            userId: action.localId,
            authToken: action.idToken,
            expiresIn: action.expiresIn
        }
        return newState;
    } else if(action.type === 'NOTIFY_FOLLOW_MODAL') {
        const newState = {
            ...state
        }
        newState.notifyfollowModal = action.value;
        return newState;
    } else if(action.type === 'SET_USER_DATA') {
        const newState = {
            ...state
        }
        newState.userData = action.value;
        return newState;
    }

    return state;
}

export default reducer;